import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchEcrituresComptables = async () => {
  const response = await axios.get(`${API_URL}/api/ecritures-comptables`);
  return response.data;
};

export const fetchEcritureComptableById = async (id) => {
  const response = await axios.get(`${API_URL}/api/ecritures-comptables/${id}`);
  return response.data;
};

export const createEcritureComptable = async (ecritureData) => {
  const response = await axios.post(`${API_URL}/api/ecritures-comptables`, ecritureData);
  return response.data;
};

export const updateEcritureComptable = async (id, ecritureData) => {
  const response = await axios.put(`${API_URL}/api/ecritures-comptables/${id}`, ecritureData);
  return response.data;
};

export const deleteEcritureComptable = async (id) => {
  await axios.delete(`${API_URL}/api/ecritures-comptables/${id}`);
};
